<template>
  <div class="bill-wrapper">
    <!--搜索条件-->
    <div class="header">
      <el-row :gutter="8">
        <el-form ref="form" :model="form" label-width="80px">
          <el-col :span="6">
            <el-form-item label="结算日期">
              <el-date-picker
                v-model="form.settleDate"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="推送日期">
              <el-date-picker
                v-model="form.pushTime"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="订单号">
              <el-input v-model="form.orderNumber" placeholder="可输入子单号/售后单号查询"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-button type="primary" @click="onSubmit" class="btn">搜索</el-button>
            <el-button class="btn default-btn" @click="resetData">重置</el-button>
          </el-col>
        </el-form>
      </el-row>
    </div>
    <div class="table-wrapper">
      <div class="tabs">
        <span class="tab" :class="{'active-tab': activeTab === 3}" @click="goToBillList(3)">待确认账单</span>
        <span class="tab" :class="{'active-tab': activeTab === 5}" @click="goToBillList(5)">已确认</span>
        <span class="tab" :class="{'active-tab': activeTab === 4}" @click="goToBillList(4)">申诉账单</span>
      </div>
      <el-dropdown trigger="click" size="medium" placement="bottom" class="batchbtn m-r-10">
        <el-button type="primary" size="small">
          批量操作
          <i class="el-icon-caret-bottom el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <!-- <el-dropdown-item @click.native="exportData(1)" v-if="activeTab === 3">批量确认</el-dropdown-item> -->
          <el-dropdown-item @click.native="exportData(2)" >导出明细</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <!-- 待确认账单表格 -->
      <wait-confirm-bill v-show="activeTab === 3"
                         :tableData="tableData"
                         :loading="loading"
                         :handleSizeChange="handleSizeChange"
                         :handleCurrentChange="handleCurrentChange"
                         :currentPage="currentPage"
                         :pageSize="pageSize"
                         :totalCount="totalCount"
                         :handleSelectionChange="handleSelectionChange"
                         :selectKeys="selectKeys"
                         :goAccountConfirm="goAccountConfirm"
                         :goAccountAppeal="goAccountAppeal"
                         ref="waitConfirmChild"
      />
      <!-- 已确认账单表格-->
      <confirm-bill v-show="activeTab === 5"
                    :tableData="tableData"
                    :loading="loading"
                    :handleSizeChange="handleSizeChange"
                    :handleCurrentChange="handleCurrentChange"
                    :currentPage="currentPage"
                    :pageSize="pageSize"
                    :totalCount="totalCount"
                    :handleSelectionChange="handleSelectionChange"
                    ref="confirmChild"
      />
      <!-- 申诉账单表格-->
      <appeal-confirm-bill v-show="activeTab === 4"
                           :tableData="tableData"
                           :loading="loading"
                           :handleSizeChange="handleSizeChange"
                           :handleCurrentChange="handleCurrentChange"
                           :currentPage="currentPage"
                           :pageSize="pageSize"
                           :totalCount="totalCount"
                           :handleSelectionChange="handleSelectionChange"
                           ref="appealConfirmChild"
      />
      <!-- 账单确认弹窗-->
      <el-dialog
        class="settle-modal"
        :visible.sync="billConfirmDialog"
        width="30%"
        :append-to-body="true"
        >
       <span slot="title" class="dialog-title">
        <span class="title">账单确认</span>
         <span class="sub-title" style="color: #FF9D0C">(确认按钮请谨慎操作)</span>
      </span>
        <span slot="footer" class="dialog-footer">
           <el-button class="btn" @click="handleClose('billConfirm')">取消</el-button>
           <el-button type="primary" @click="goAccountConfirm(null)">确认({{selectKeys.length}}条)</el-button>
      </span>
        <div class="form-wrapper">
          <div>
            <span class="label">销售总金额</span>
            <span class="value">{{confirmModalData.purchaseTotalAmount}}</span>
          </div>
          <div>
            <span class="label">退货总金额</span>
            <span class="value">{{confirmModalData.refundTotalAmount}}</span>
          </div>
          <div>
            <span class="label">待结算总金额</span>
            <span class="value">{{confirmModalData.unSettleTotalAmount}}</span>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import WaitConfirmBill from "./components/waitConfirmBill";
import ConfirmBill from "./components/confirmBill";
import AppealConfirmBill from "./components/appealConfirmBill";
import {queryAccountList, doAccountConfirm, doAccountAppeal} from "@/models/r4SettleModel";
import moment from "moment";
import r4SettleApiList from "../../../service/basic/r4SettleApiList";
import { sumBy, map } from "lodash";
export default {
  components: {
    WaitConfirmBill,
    ConfirmBill,
    AppealConfirmBill
  },
  data() {
    return {
      billConfirmDialog: false,
      reason: '',
      dialogImageUrl: '',
      dialogImgVisible: false,
      accountDialogVisible: false,
      dialogVisible: false,
      dialogVisible2: false,
      billDialog: false,
      appealDialog: false,
      tableData: [],
      loading: false,
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
      },
      form: {
        settleDate: '',
        orderNumber: '',
        pushTime: ''
      },
      selectKeys:[], // 选中对象
      modalData: {
        num: '',
        date: '',
        company: undefined
      },
      options: [],
      activeTab: 3,
      confirmModalData: {
        purchaseTotalAmount: null,
        refundTotalAmount: null,
        unSettleTotalAmount: null,
      },
      confirmBtnLoading: false,
    };
  },
  created() {

  },
  mounted() {
    this.loadAccountList(3);
  },
  methods: {
    // 对账明细
    loadAccountList(settleStatus) {
      const params = {
        orderNumber: this.form.orderNumber,
        pageIndex: this.currentPage - 1,
        pageSize: this.pageSize,
        settleStatus,
        supplierId: Number(localStorage.getItem('supplier_id')),
        settleDateStart:
          this.form.settleDate.length > 0
            ? `${moment(this.form.settleDate[0]).format(
              "YYYY-MM-DD"
            )} 00:00:00`
            : undefined,
        settleDateEnd:
          this.form.settleDate.length > 0
            ? `${moment(this.form.settleDate[1]).format(
              "YYYY-MM-DD"
            )} 23:59:59`
            : undefined,
        pushTimeStart:
          this.form.pushTime.length > 0
            ? `${moment(this.form.pushTime[0]).format(
              "YYYY-MM-DD"
            )} 00:00:00`
            : undefined,
        pushTimeEnd:
          this.form.pushTime.length > 0
            ? `${moment(this.form.pushTime[1]).format(
              "YYYY-MM-DD"
            )} 23:59:59`
            : undefined,
      }
      this.loading = true;
      queryAccountList(params).then((res) => {
        this.loading = false;
        console.log(res, "res");
        this.tableData = res.content.map((item, index) => {
          item.serialNum = index + 1 + (this.currentPage - 1) * this.pageSize;
          return item;
        });
        this.totalCount = Number(res.totalElements) || 0;
      }).catch((err) => {
        this.loading = false;
        console.log(err);
        this.$message.error(err.message);
      });
    },
    // 申诉
    goAccountAppeal(appealReason, item) {
      const params = {
        appealReason,
        purchaseCorpName: item.purchaseCorpName,
        settleNo: item.settleNo
      }
      this.confirmBtnLoading = true;
      doAccountAppeal(params).then((res) => {
        this.$refs.waitConfirmChild.appealLoading = false;
        console.log(res, "res");
        this.currentPage = 1;
        this.pagesize = 10;
        this.$refs.waitConfirmChild.appealBillDialog = false;
        this.loadAccountList(this.activeTab);
      }).catch((err) => {
        this.$refs.waitConfirmChild.appealLoading  = false;
        console.log(err);
        this.$message.error(err.message);
      });
    },
    // 批量确认
    goAccountConfirm(selectKeys) {
      console.log(this.selectKeys, "this.selectKeys");
      console.log(selectKeys, "selectKeys");
      const settleNo = map((selectKeys || this.selectKeys), "settleNo");
      console.log(settleNo, "settleNo");
      const params = {
        settleNo,
      }
      this.confirmBtnLoading = true;
      doAccountConfirm(params).then((res) => {
        this.confirmBtnLoading = false;
        console.log(res, "res");
        this.currentPage = 1;
        this.pagesize = 10;
        this.billConfirmDialog = false;
        this.loadAccountList(this.activeTab);// todo：详情清空
        this.$refs.waitConfirmChild.clearDetail();
      }).catch((err) => {
        this.confirmBtnLoading = false;
        console.log(err);
        this.$message.error(err.message);
      });
    },
    // 切换tab
    goToBillList(type) {
      this.activeTab = type;
      switch (type) {
        case 3:
          this.loadAccountList(3);
          this.$refs.waitConfirmChild.clearDetail();
          break;
        case 5:
          this.loadAccountList(5);
          this.$refs.confirmChild.clearDetail();
          break;
        case 4:
          this.loadAccountList(4);
          this.$refs.appealConfirmChild.clearDetail();
          break;
      }
    },
    handleClose(type) {
      switch (type) {
        case 'billConfirm':
          this.billConfirmDialog = false;
          break;
      }
    },
    // 每页条数改变
    handleSizeChange(val) {
      this.pageSize = val;
      this.loadAccountList(this.activeTab);
    },
    // 页码改变
    handleCurrentChange(val) {
      this.currentPage = val;
      this.loadAccountList(this.activeTab);
    },
    onSubmit() {
      console.log(this.form, "submit");
      this.currentPage = 1;
      this.pageSize = 10;
      this.loadAccountList(this.activeTab);
    },
    resetData() {
      this.form = {
        settleDate: '',
        orderNumber: '',
        pushTime: ''
      }
      this.loadAccountList(this.activeTab);
    },
    exportData(type) {
      switch (type) {
        case 1: // 批量确认
          if (this.selectKeys.length === 0) {
            this.$message.error('请先勾选数据');
            return;
          }
          this.billConfirmDialog=true;
          this.confirmModalData.refundTotalAmount = Number(sumBy(this.selectKeys, "refundTotalAmount")).toFixed(2)
          this.confirmModalData.purchaseTotalAmount = Number(sumBy(this.selectKeys, "purchaseTotalAmount")).toFixed(2)
          this.confirmModalData.unSettleTotalAmount = Number(sumBy(this.selectKeys, "unSettleTotalAmount")).toFixed(2)
          break;
        case 2:
          if (this.selectKeys.length === 0) {
            this.$message.error('请先勾选数据');
            return;
          }
          const selectData = map(this.selectKeys, "settleNo");
          const selectKeys = selectData.join(",");
          window.open(myhostname + r4SettleApiList.exportData + "?settleNo="+ selectKeys +"&access_token=" + localStorage.getItem('token'));
          break;
      }
    },
    // 勾选table
    handleSelectionChange(val) {
      console.log(val, "val");
      this.selectKeys = val;
    }
  },
};
</script>
<style lang="scss" scoped>
.bill-wrapper {
  width: 100%;
  height: auto;
  padding: 12px 0;
  background: #fff;

  .btn {
    width: 70px;
    height: 30px;
    background: linear-gradient(132deg, #FF602F 0%, #FF3722 100%, #FF3621 100%, #FF3621 100%, #FF3722 100%);
    border-radius: 6px;
    font-size: 8px;
    font-family: MicrosoftYaHei;
    color: #FFFFFF;
    padding: 0;
    line-height: 30px;
    margin-top: 5px;
  }

  .default-btn {
    background: #fff;
    font-size: 8px;
    font-family: MicrosoftYaHei;
    color: #666666;
    border-radius: 6px;
    border: 1px solid #D5D5D5;
  }

  .batchbtn {
    float: right;
    margin-bottom: 8px;
  }

  .tabs {
    float: left;
    margin-top: 8px;
    >span:first-child {
      border-radius: 4px 0px 0px 0px;
    }
    >span:nth-child(2) {
      margin-left: -5px;
    }
    > span:last-child {
      border-radius: 0px 4px 0px 0px;
      margin-left: -5px;
    }
  }
  .tab {
    width: 60px;
    height: 22px;
    background: #73818C;
    color: #fff;
    padding: 6px 18px;
    cursor: pointer;
  }
  .active-tab {
    background: #A4B4C1;
  }
  .el-range-editor.el-input__inner {
    width: 100%;
  }
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  /deep/ .el-icon-date:before {
    position: absolute;
    top: -4px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/r4SettlementReport/billConfirm/billConfirm.vue